import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiResponse } from 'src/app/interfaces/base-entity';
import {
  CorpacerosIntegrationConfigDTO,
  CorpacerosPlaceholder,
  SaveCorpacerosIntegrationConfigCommand,
  TestCorpacerosConnectionCommand,
  TestCorpacerosConnectionResult,
} from '../models/corpaceros-integration-config.models';

@Injectable({
  providedIn: 'root'
})
export class CorpacerosIntegrationConfigService {
  private http = inject(HttpClient);
  private baseUrl = `${environment.host}/api/CorpacerosIntegrationConfig`;

  getByCompany(companyId: number): Observable<ApiResponse<CorpacerosIntegrationConfigDTO | null>> {
    return this.http.get<ApiResponse<CorpacerosIntegrationConfigDTO | null>>(`${this.baseUrl}/byCompany/${companyId}`);
  }

  save(command: SaveCorpacerosIntegrationConfigCommand): Observable<ApiResponse<number>> {
    return this.http.post<ApiResponse<number>>(`${this.baseUrl}/save`, command);
  }

  test(command: TestCorpacerosConnectionCommand): Observable<ApiResponse<TestCorpacerosConnectionResult>> {
    return this.http.post<ApiResponse<TestCorpacerosConnectionResult>>(`${this.baseUrl}/test`, command);
  }

  delete(id: number): Observable<ApiResponse<boolean>> {
    return this.http.delete<ApiResponse<boolean>>(`${this.baseUrl}/delete/${id}`);
  }

  getAvailablePlaceholders(): Observable<CorpacerosPlaceholder[]> {
    return this.http.get<CorpacerosPlaceholder[]>(`${this.baseUrl}/available-placeholders`);
  }
}
